module.exports = __webpack_public_path__ + "static/img/home_icon2.c1ac557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_icon2.png
// module id = 577
// module chunks = 4 5